import { gql } from '@apollo/client'

export const GET_USERS = gql`
  query GetTransferAdmins {
    users {
      id
      email
      first_name
      last_name
      phone_number
      profile_image_url
      disabled
      isAvailable
      twilio_worker_id
      enable_phone_transfers
    }
  }
`

export const GET_TRANSFER_CALL = gql`
  query GetTransferCall($id: String) {
    call(id: $id) {
      id
      status
    }
  }
`
